<script>
  /* variables */
  let gallery = null;

  /* constants */
  // how many images in each galleries
  const galleries = {
    1: 7,
    2: 4,
    3: 4,
    4: 4,
    5: 2,
    6: 2,
    7: 6,
    8: 5
  };

  // functions
  const openGallery = gall => {
    gallery = gall;
  };
  const closeGallery = () => {
    gallery = null;
  };
  const prevGallery = () => {
    gallery = gallery > 1 ? gallery - 1 : 9;
    const modal = document.getElementById("modal");
    modal.scrollTo(0, 0);
  };
  const nextGallery = () => {
    gallery = gallery < 9 ? gallery + 1 : 1;
    const modal = document.getElementById("modal");
    modal.scrollTo(0, 0);
  };
</script>

<style>
  .title-area {
    margin: 4rem auto;
    width: 80%;
    max-width: 700px;
  }
  .main-title,
  .sub-title {
    background: #13100b;
    background: rgba(19, 16, 11, 0.8);
    color: white;
    text-shadow: 1px 2px 2px #0005;
    display: inline-block;
  }
  .main-title {
    padding: 10px 15px;
    font-weight: 400;
    font-size: 2rem;
    letter-spacing: 1px;
    margin-bottom: 1rem;
  }
  .sub-title {
    text-transform: uppercase;
    padding: 10px 15px;
    font-weight: 400;
    font-size: 1.2rem;
    letter-spacing: 1px;
  }
  .thumbs-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 95%;
    max-width: 800px;
    margin: 5rem auto;
  }
  .thumb {
    width: 200px;
    height: 200px;
    /* object-fit: cover;
    object-position: 50% 10%;  */
    margin: 1rem;
    cursor: pointer;
    transition: opacity 0.3s;
    overflow: hidden;
    border-radius: 3px;
    box-shadow: 2px 3px 4px #0002;
  }
  .thumb:hover,
  .thumb:focus {
    opacity: 0.8;
  }
  .thumb img {
    object-fit: cover;
    object-position: 50% 10%;
  }
  .textbox {
    margin: 2rem auto;
    width: 700px;
    max-width: 90%;
    box-sizing: border-box;
    padding: 1rem 2rem;
    background: #13100b;
    background: rgba(19, 16, 11, 0.8);
    color: white;
    font-weight: 300;
    box-shadow: 2px 3px 4px #0002;
    line-height: 1.5;
    border-radius: 3px;
    font-size: 1.1rem;
  }
  .modal {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(175, 99, 128);
    background: radial-gradient(
      at 50% 100%,
      rgba(247, 207, 115, 1) 0%,
      rgba(235, 115, 76, 1) 20%,
      rgba(175, 99, 128, 1) 60%,
      rgba(59, 65, 122, 1) 100%
    );
    background-attachment: fixed;
  }
  .modal-content {
    width: 84%;
    max-width: 1200px;
    margin: 4rem auto;
    text-align: center;
  }
  .modal-img-wrapper {
    margin-bottom: 2rem;
  }
  img {
    max-width: 100%;
  }
  .gallery-arrow {
    position: fixed;
    top: calc(50% - 25px);
    height: 50px;
    width: 8%;
    z-index: 100;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff7;
    font-size: 3rem;
    line-height: 3rem;
    user-select: none;
    transition: color 0.3s ease-in-out;
  }
  .gallery-arrow:hover {
    color: white;
    /* text-shadow: 0 0 2px #0004; */
  }
  .gallery-arrow__prev {
    left: 0;
  }
  .gallery-arrow__next {
    right: 0;
  }
  .footer {
    margin-top: 30rem;
    padding: 3rem;
    background: #3d427a;
    background: rgba(61, 66, 122, 0.8);
    color: #d7c3ab;
    background-image: linear-gradient(
      to right,
      rgba(61, 66, 122, 1),
      rgba(140, 97, 71, 0.6),
      rgba(61, 66, 122, 1)
    );
    box-shadow: 0px -3px 5px #b46e6a47;
    border-radius: 100%/8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .footer a {
    color: inherit;
    border-bottom: 1px solid #d7c3ab63;
  }
  .footer a:hover {
    text-decoration: none;
    border-bottom: 1px solid #d7c3ab;
  }
  @media (max-width: 639px) {
    .thumb {
      margin: 10px;
    }
    .modal-content {
      margin: 4rem 2.5rem;
      width: initial;
    }
    .gallery-arrow {
      width: 2.5rem;
      font-size: 2.5rem;
    }
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>

<main>
  <div class="title-area">
    <div>
      <h1 class="main-title">SUNSET CENTO</h1>
    </div>
    <div>
      <div class="sub-title">Kathryn Hummel</div>
    </div>
  </div>

  <div class="thumbs-wrapper">
    {#each { length: 9 } as _, i}
      <div class="thumb" on:click={() => openGallery(i + 1)}>
        <img
          src={'./media/cento' + (i + 1) + '-thumb.jpg'}
          alt={'gallery ' + (i + 1)} />
      </div>
    {/each}
  </div>

  <div class="textbox">
    <p>
      Sunset Cento is a series of nine multimedia poems based on
      de/re/constructed text, images, audio and video submitted by
      participants around the world.
    </p>

    <p>
      The point of connection in the project is sunset, a simultaneously unique
      and commonplace daily event; textual impressions, when broken down (line
      by line for poetry and punctuation to punctuation for prose) revealed
      shared themes of freedom, release and relief, contemplation, dreaming and
      exploration. Images of sunset were commonly framed by natural settings
      (sea; lakes; desert; mountains), with occasional urban and industrial
      motifs.
    </p>

    <p>
      In making, the cento has no predictable outcome, though it became my
      increasing desire as editor/curator/assembler to emphasise the
      collaborative nature of the project, with acknowledgements of contributors
      consistently composing the final image/shot of each cento; to layer or
      distort images into digital collage to reflect the process of textual
      centos; to trouble the sentimental associations with, as well as the
      natural beauty and visual splendour of sunset through the medium of the
      centos' creation and presentation.
    </p>

    <p>
      Ugliness, labour, disturbance, obsessiveness, panic and tedium might all
      be present too, as the project draws on concepts behind found, eco and
      digital poetry/art to portray nine merged experiences of space (analogue
      and digital), perspective and creative identity.
    </p>

  </div>

  <footer class="footer">
    <p>
      Kathryn Hummel: Sunset Cento
      <br />
      Poetry collage.
    </p>
    <p>
      Producer Virpi Vairinen
      <br />
      Web design Teemu T. Tuovinen
      <br />
      Digital Residence at Nokturno
    </p>

    <p>
      <a href="https://sunsetcento.tumblr.com/">
        Kathryn Hummel´s residence diary
      </a>
    </p>

    <p>
      <a href="https://nokturno.fi">Nokturno.fi</a>
    </p>
  </footer>

  {#if gallery}
    <div class="modal" id="modal" on:click={closeGallery}>
      <div class="modal-content">
        <div
          class="gallery-arrow gallery-arrow__prev"
          on:click|stopPropagation={prevGallery}>
          {'<'}
        </div>
        <div
          class="gallery-arrow gallery-arrow__next"
          on:click|stopPropagation={nextGallery}>
          {'>'}
        </div>
        {#if gallery === 9}
          <div class="modal-img-wrapper">
            <video autoplay controls>
            <source src="./media/cento_txt.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          </div>
        {:else}
          {#each { length: galleries[gallery] } as _, i}
            <div class="modal-img-wrapper">
              <img
                src={'./media/cento' + gallery + '-' + i + '.jpg'}
                alt={'image ' + i} />
            </div>
          {/each}
        {/if}
      </div>
    </div>
  {/if}
</main>
